/**
 * Whether the connected nekoapi exposes Member.is_currently_working on roster payloads.
 * Production (nekohr.nekoapi.xyz) may still return only legacy fields until migration 0058 is deployed.
 */
export function teamRosterStatusSupported(members) {
  const list = Array.isArray(members) ? members : [];
  if (!list.length) return false;
  return list.some((m) =>
    Object.prototype.hasOwnProperty.call(m, "is_currently_working")
  );
}

/** Whether nekoapi exposes Member.koneko_excluded_from_month (migration 0059). */
export function teamKonekoDepartureMonthSupported(members) {
  const list = Array.isArray(members) ? members : [];
  if (!list.length) return false;
  return list.some((m) =>
    Object.prototype.hasOwnProperty.call(m, "koneko_excluded_from_month")
  );
}

/** Whether nekoapi exposes Member.payroll_monthly_treatment (migration 0060). */
export function teamPayrollFieldsSupported(members) {
  const list = Array.isArray(members) ? members : [];
  if (!list.length) return false;
  return list.some((m) =>
    Object.prototype.hasOwnProperty.call(m, "payroll_monthly_treatment")
  );
}

/** Whether nekoapi exposes Member.last_working_date (migration 0061). */
export function teamEmploymentDatesSupported(members) {
  const list = Array.isArray(members) ? members : [];
  if (!list.length) return false;
  return list.some((m) =>
    Object.prototype.hasOwnProperty.call(m, "last_working_date")
  );
}

/** Row from `api/users/team-members/` with a persisted Member pk (not timesheet backfill). */
export function isRealTeamMemberRow(row) {
  if (!row || typeof row !== "object") return false;
  const id = Number(row.id);
  return Number.isFinite(id) && id > 0;
}
